import UserInfo from "../../interfaces/UserInfo";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Function to search for users (for mentions)
export async function searchUsersForMentions(
  authToken: string,
  query: string
): Promise<UserInfo[] | null> {
  const queryParams = new URLSearchParams();
  queryParams.append('q', query);

  try {
    const response = await fetch(`${API_BASE_URL}/users/search?${queryParams.toString()}`, {
      headers: {
        'Authorization': `Bearer ${authToken}`,
      },
    });

    if (!response.ok) {
      console.error(`Failed to search users:`, response.status, response.statusText);
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error(`Error searching users:`, error);
    return null;
  }
}
